export default __webpack_public_path__ + "static/media/driver-slide2.c3b62b58.jpg";